<template>
  <div class="soc_back_videos">
    <div class="back_mark" v-if="isDownload"></div>
    <!-- 时间刻度指示线 -->
    <div
      class="video_cursor"
      :style="{ left: cursorLeft + 'px', opacity: cursorOpacity }"
    >
      <div class="video_cursor_content">
        <span class="time_format"> {{ formatCursorTime }} </span>
      </div>
    </div>
    <div class="back_camera_item">
      <div class="camera_title nor">
        <i @click="handleChangeViewMin" title="缩小刻度" class="el-icon-minus"></i>
        <soc-bar
          side-id="video-b-side"
          active-color="#535F7D"
          max="105"
          :is-show-tips="true"
          :format-tooltip="formatTooltip"
          v-model="scale"
          @change="handleChangeView"
        ></soc-bar>
        <i @click="handleChangeViewPlus" title="放大刻度" class="el-icon-plus"></i>
      </div>
      <!-- camera_back_data--over scale > 40代表小于24小时支持拖动，改变鼠标样式 -->
      <div
        class="camera_back_data time_scale"
        @mousewheel="scalWheel"
        :style="Object.keys(mData).length > 3 ? 'padding-right:65px' : ''"
      >
        <div
          :style="'left: ' + containerLeft + 'px;'"
          :class="[
            'camera_back_data--over',
            'width_scal_' + viewType,
            { colResize: scaleNum > 36 },
          ]"
          @mousedown="timeAxisDown"
        >
          <div @mousedown.stop class="scale_container" id="scaleWidth">
            <template v-for="(item, key) in scaleNum">
              <div
                :class="['scale_un', item % labelInterVal === 0 ? 'ps' : '']"
                :key="key"
              >
                <!--{{item}}-->
                <template v-if="item === 1">
                  <div class="label">{{ formatDate(0) }}</div>
                </template>
                <template v-if="item % labelInterVal === 0">
                  <div class="label">{{ formatScaleTime(item) }}</div>
                </template>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="list_content_container">
      <div
        :class="[
          'back_camera_item active',
          activeWindow === key ? 'active' : '',
          downloadActive === key ? 'download' : '',
        ]"
        v-for="(camera, key) in isDelayPlay ? partData : mData"
        :key="key"
      >
        <div class="camera_title noresize" :title="camera[0].cameraName">
          窗口： {{ camera[0].cameraName }}
        </div>
        <div class="camera_back_data">
          <div
            class="data_content"
            @mouseover="handleMouseHover($event, key)"
            @mousemove="handleMouseHover($event, key)"
            @mouseleave="handleMouseLeave"
          >
            <!-- @click="switchList(key, camera)" -->
            <!-- :style="{
                left:
                  (activeWindow === key ? getCurLeft : handleVideoProgress(key)) + 'px',
              }" -->
            <div
              class="cursor_div"
              :ref="'cursor_div' + key"
              v-if="isSyncPlay ? key === 0 : true"
              :style="{
                left: getCurLeft + 'px',
              }"
              @mousedown="cursorDown($event, camera, key)"
            >
              <i class="el-icon-caret-top"></i>
            </div>
            <!-- overflow: hidden; -->
            <div style="width: 100%; position: relative; height: 100%">
              <div
                :class="['video_data_list', hasTypeClass(item.recordType)]"
                :style="hasClass(item.StartTime, item.EndTime)"
                v-for="(item, index) in camera"
                :key="index"
                @dblclick="handleClickPlay($event, key, item, index)"
              ></div>
            </div>
          </div>
          <!-- left: getDownloadLeft + 'px', -->
          <div
            class="download_container"
            :style="{
              left: getDownloadLeft + 'px',
              width: getDownloadWidth + 'px',
            }"
            v-if="isDownload && downloadActive === key"
          >
            <div class="download_content">
              <div
                class="download_content_left_cur"
                :data-title="downloadSTime"
                @mousedown="handleStartDrag($event)"
              ></div>
              <div
                class="download_content_right_cur"
                :data-title="downloadETime"
                @mousedown="handleEndDrag($event)"
              ></div>
              <div :class="['download_btn', isBottom ? 'bottom' : '']">
                <el-button
                  type="primary"
                  size="mini"
                  style="width: 64px; height: 28px"
                  @click="
                    handleDownloadConfirm(camera[0].cameraCode, camera[0].cameraName)
                  "
                >
                  下载
                </el-button>
                <el-button
                  type="info"
                  size="mini"
                  style="width: 64px; height: 28px"
                  @click="handleCancelDownload"
                  >取消
                </el-button>
              </div>
            </div>
          </div>
          <div
            class="download_container timeClass"
            style="width: 140px; right: 85px"
            v-if="isTimeInput && timeloadActive === key"
          >
            <div class="download_content timeClassContent">
              <el-input
                v-model="inputTimeValue"
                size="small"
                placeholder="例:20210701161000"
              ></el-input>
              <div :class="['download_btn', isBottom ? 'bottom' : '']">
                <el-button
                  type="primary"
                  size="mini"
                  style="width: 64px; height: 28px"
                  @click="startVideoPlay()"
                >
                  确定
                </el-button>
                <el-button
                  type="info"
                  size="mini"
                  style="width: 64px; height: 28px"
                  @click="cancelVideoPlay"
                  >取消
                </el-button>
              </div>
            </div>
          </div>
          <!-- <div class="down_load_icon" v-if="activeWindow === key">
            <el-tooltip class="item" effect="dark" content="下载" placement="top">
              <i
                style="color: rgb(0, 106, 226)"
                class="el-icon-download"
                @click="handleDownload($event, key, camera[0])"
              ></i>
            </el-tooltip>
          </div>
          <div class="down_load_icon" v-if="activeWindow === key" style="right: 35px">
            <el-tooltip class="item" effect="dark" content="删除" placement="top">
              <i
                style="color: rgb(0, 106, 226)"
                class="el-icon-delete"
                @click="deleteInfo($event, key, camera[0])"
              ></i>
            </el-tooltip>
          </div>
          <div class="down_load_icon" v-if="activeWindow === key" style="right: 60px">
            <el-tooltip class="item" effect="dark" content="快速定位" placement="top">
              <i
                style="color: rgb(0, 106, 226)"
                class="el-icon-caret-bottom"
                @click="handleGo($event, key, camera)"
              ></i>
            </el-tooltip>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SocBar from "./soc-bar";
import DayJs from "dayjs";

export default {
  name: "back-videos",
  props: {
    startTime: {
      type: Number,
      default: 0,
    },
    endTime: {
      type: Number,
      default: 0,
    },
    videosData: {
      type: String,
      default: () => null,
    },
    left: {
      type: String,
      default: null,
    },
    width: {
      type: String,
      default: null,
    },
    playTime: {
      type: Number,
      default: null,
    },
    wnd: {
      type: Number,
      default: 1,
    },
    isDelayPlay: {
      type: Boolean,
      default: false,
    },
    isSyncPlay: {
      type: Boolean,
      default: false,
    },
    // 列表播放进度信息
    playListInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 选窗口时触发一次列表选中
    checkedCameraIndex: {
      type: Number,
      default: () => {
        return null;
      },
    },
  },
  components: { SocBar },
  data() {
    return {
      // 内容区域left值，小于72小时拖动时使用，列表/刻度指示针需要加上对应的偏移量
      containerLeft: 0,
      canDownLoad: true,
      paramsText: "",
      scale: 75,
      scaleNum: 36,
      interval: 2,
      timestamp: 1563033600000,
      labelInterVal: 3,
      scaleUn: 60,
      // 时间轴视图类型
      viewType: "72hour",
      scaleLength: 72 * 60 * 60 * 1000,
      activeWindow: "",
      cursorLeft: -1,
      cursorOpacity: 0,
      moveCall: null,
      cursorValue: 0,
      cLeft: 0,
      mData: [], // 搜索视频列表
      partData: [], // 分段视频列表
      isDrag: false,
      isDownload: false,
      isTimeInput: false,
      timeObj: {},
      inputTimeValue: "",
      downloadDefault: {
        left: 32,
        width: 0,
      },
      moveValue: 0,
      moveLeft: 0,
      downloadActive: "",
      timeloadActive: "",
      isBottom: false,
      progressObject: {},
      activeProgress: 0,
      // 当前播放视频段Left值
      playingLeft: 0,
    };
  },
  computed: {
    getScaleWidth() {
      //   return this.width ? Number(this.width.replace(/px/g, "")) - 135 - 80 : 0;
      return this.width ? Number(this.width.replace(/px/g, "")) - 135 - 130 : 0;
    },
    // 播放列表进度三角符号向右偏移值
    disCursorLeft() {
      return this.containerLeft - 7;
    },
    // 1px代表的时间戳
    getSecWidth() {
      // console.log(this.getScaleWidth);
      return this.getScaleWidth / this.scaleLength;
    },
    getTimeRangeType() {
      return (this.endTime - this.startTime) / (60 * 60 * 1000);
    },
    getChangeTime() {
      return this.startTime + this.endTime;
    },
    getStartTimeM() {
      return DayJs(this.startTime).format("HH");
    },
    getStartTimeS() {
      return DayJs(this.startTime).format("mm");
    },
    localOffset() {
      let date = new Date();
      return date.getTimezoneOffset() * 60000;
    },
    getLeft() {
      return this.left ? Number(this.left.replace(/px/g, "")) : 0;
    },
    formatCursorTime() {
      return DayJs(this.timestamp + this.cursorValue / this.getSecWidth).format(
        "YYYY-MM-DD HH:mm:ss"
      );
    },
    getCurLeft() {
      return this.playTime
        ? (new Date(this.playTime).getTime() - this.timestamp) * this.getSecWidth
        : 0;
    },
    getDownloadWidth() {
      return this.downloadDefault.width + this.moveValue < 0
        ? 0
        : this.downloadDefault.width + this.moveValue;
    },
    getDownloadLeft() {
      return this.downloadDefault.left + this.moveLeft;
    },
    getDownloadStartTime() {
      return (
        this.timestamp +
        (this.getDownloadLeft + Math.abs(this.containerLeft) - 32) / this.getSecWidth
      );
    },
    getDownloadEndTime() {
      return this.getDownloadStartTime + this.getDownloadWidth / this.getSecWidth;
    },
    downloadSTime() {
      return DayJs(this.getDownloadStartTime).format("HH:mm:ss");
    },
    downloadETime() {
      // this.paramsText = JSON.stringify(DayJs(this.getDownloadEndTime).format('HH:mm:ss'))
      return DayJs(this.getDownloadEndTime).format("HH:mm:ss");
    },
  },
  watch: {
    // playListInfo: {
    //   handler: function(newVal, oldVal) {
    //     console.log(newVal, '更新值---')
    //   },
    //   deep: true
    // },
    checkedCameraIndex: function (newVal, oldVal) {
      this.activeWindow = newVal;
    },
    startTime: {
      handler(newVal, oldVal) {
        this.timestamp = newVal;
      },
      immediate: true,
    },
    videosData: {
      handler(newVal) {
        this.mData = newVal ? JSON.parse(newVal) : {};
        // console.log(this.mData, "this.mData11");
        let _arr = newVal ? JSON.parse(newVal) : null;
        if (!_arr) {
          return;
        }
        Object.keys(_arr).forEach((key) => {
          this.progressObject[key] = "";
        });
      },
      immediate: true,
    },
    playTime: {
      handler(newVal) {
        if (!newVal) {
          return;
        }
        this.progressObject[this.wnd] = newVal;
        // console.info("选中窗口进度值#:", this.progressObject[this.wnd]);
      },
      immediate: true,
    },
    // 刻度实现思路：72小时事例this.changeView(36, 60, 3)--第一个参数：分36份那每份就是2小时，第二个参数：60 * interval每份代表时间，第三个参数：每三个刻度展示一次刻度值
    // 说明：例如48 X (72 / 24) = 144********48是分割份数，72 / 24是刻度容器的扩充比例为了实现拖动
    scale: function (newVal, oldVal) {
      this.changeViewPosition(newVal, oldVal);
      // 48个小时视图**************
      if (newVal === 0) {
        this.changeView(36, 480, 3, "48hour");
        this.scaleLength = 8 * 72 * 60 * 60 * 1000;
        console.log(this.getSecWidth);
        return;
      }
      // 24小时视图 36 X (72 / 24) = 144
      if (newVal === 15) {
        this.changeView(36, 240, 3, "24hour");
        this.scaleLength = 4 * 72 * 60 * 60 * 1000;
        console.log(this.getSecWidth);
        return;
      }
      // 12小时   36 X (72 / 12) = 144
      if (newVal === 30) {
        this.changeView(36, 120, 3, "12hour");
        this.scaleLength = 2 * 72 * 60 * 60 * 1000;
        console.log(this.getSecWidth);
        return;
      }
      // 6小时视图*** 30 X (72 / 6) = 360
      if (newVal === 45) {
        this.changeView(36, 60, 3, "6hour");
        this.scaleLength = 72 * 60 * 60 * 1000;
        console.log(this.getSecWidth);
        return;
      }
      // 两小时视图 36 X (6 / 2) = 108
      if (newVal === 60) {
        this.changeView(108, 20, 3, "2hour");
        this.scaleLength = 24 * 60 * 60 * 1000;
        console.log(this.getSecWidth);
      }
      // 一小时视图*** 36 X (6 / 1) = 216
      if (newVal === 75) {
        this.changeView(216, 10, 3, "1hour");
        this.scaleLength = 12 * 60 * 60 * 1000;
        console.log(this.getSecWidth);
      }
      // 30分钟视图*** 36 X (6 / 0.5) = 432
      if (newVal === 90) {
        this.changeView(432, 5, 3, "30minute");
        this.scaleLength = 6 * 60 * 60 * 1000;
        console.log(this.getSecWidth);
      }
      // 15分钟视图***36 X (6 / 0.25) = 864
      if (newVal === 105) {
        this.changeView(864, 2.5, 3, "15minute");
        this.scaleLength = 3 * 60 * 60 * 1000;
        console.log(this.getSecWidth);
      }
    },
    getChangeTime: function (val) {
      console.log(">>>>>>>>>>>>>>>>", this.getTimeRangeType);
      // const type = this.getTimeRangeType
      const _hour = this.getStartTimeM;
      const _min = this.getStartTimeS;
      console.log(_hour);
      console.log(_min);
      // 默认展示1小时视图
      this.scale = 75;
      this.timestamp = this.startTime;
      this.changeView(216, 10, 3, "1hour");
      this.scaleLength = 12 * 60 * 60 * 1000;
      // if (type > 24 && type <= 72) {
      //   this.scale = 0
      //   this.timestamp = this.startTime
      //   this.handleStartTimeByMax(72)
      //   this.changeView(36, 720, 3, '72hour')
      //   this.scaleLength = 12 * 72 * 60 * 60 * 1000
      //   return
      // }
      // if (type > 6 && type <= 24) {
      //   this.timestamp = this.startTime
      //   this.scale = 30
      //   this.handleStartTimeByMax(30)
      //   this.changeView(36, 240, 3, '24hour')
      //   this.scaleLength = 4 * 72 * 60 * 60 * 1000
      //   return
      // }
      // if (type > 2 && type <= 6) {
      //   this.scale = 45
      //   this.timestamp = this.startTime
      //   this.changeView(36, 60, 3, '6hour')
      //   this.scaleLength = 72 * 60 * 60 * 1000
      //   console.log(this.getSecWidth)
      //   return
      // }
      // if (type <= 2) {
      //   this.timestamp = this.startTime
      //   this.scale = 60
      //   this.handleStartTimeByMax(5)
      //   this.changeView(108, 20, 3, '2hour')
      //   this.scaleLength = 24 * 60 * 60 * 1000
      // }
    },
  },
  mounted() {
    this.changeView(216, 10, 3, "1hour");
    this.scaleLength = 12 * 60 * 60 * 1000;
    // console.log(this.getSecWidth);
    // this.mData = [
    //   [{
    //     StartTime: '20201020110000',
    //     EndTime: '20201020180000',
    //     cameraName: '192_168_0_189',
    //     cameraCode: '05261006241863370101#cf4ffcf3ac3b41a9872940ec16d05a97',
    //     recordType: '010'}],
    //     [{
    //     StartTime: '20201020160000',
    //     EndTime: '20201021035009',
    //     cameraName: '252',
    //     cameraCode: '05261006241863370101#cf4ffcf3ac3b41a9872940ec16d05a97',
    //     recordType: '010'}],
    // ]
  },
  methods: {
    // 改变刻度视图类型时 修改刻度位置，避免进度信息'小白点'超出视野范围
    changeViewPosition(newScale, oldScale) {
      // 6小时以上包括6小时重置刻度拖动值
      if (newScale <= 45) {
        this.containerLeft = 0;
        return;
      }
      // 跨刻度拖动个数
      let discus = (newScale - oldScale) / 15;
      // 当前小三角距离父元素的left值
      let currentTimeLeft = 0;
      if (this.playListInfo && this.playListInfo[this.activeWindow]) {
        currentTimeLeft =
          (this.playListInfo[this.activeWindow] - this.startTime) * this.getSecWidth;
      }
      if (discus < 0) {
        // 缩小刻度--刻度需要向右移动三角缩小的倍数和1的差值即如果从30分钟变为1小时一个刻度跨度 需要向右移动小白点left值的1/2以此类推
        let diffValue = 1 - 1 / (Math.abs(discus) + 1);
        this.containerLeft = this.containerLeft + currentTimeLeft * diffValue;
      } else {
        // 放大刻度--刻度需要向右移动三角left值的放大倍数
        this.containerLeft = this.containerLeft - currentTimeLeft * discus;
      }
      this.containerLeft > 0 && (this.containerLeft = 0);
    },
    handleVideoProgress(key) {
      return this.progressObject[key] !== ""
        ? (this.handleTimeNumber(this.progressObject[key]) - this.timestamp) *
            this.getSecWidth
        : 0;
    },
    formatTooltip(val) {
      let timeConfig = [
        "48小时",
        "24小时",
        "12小时",
        "6小时",
        "2小时",
        "1小时",
        "30分钟",
        "15分钟",
      ];
      let index = Math.ceil(val / 15);
      if (timeConfig[index]) {
        return timeConfig[index];
      }
    },
    // 刻度格式展示
    formatScaleTime(val) {
      const time = this.timestamp + val * this.interval * this.scaleUn * 60 * 1000;
      return DayJs(time).format("HH:mm") === "00:00"
        ? DayJs(time).format("YYYY-MM-DD")
        : DayJs(time).format("HH:mm");
    },
    // 格式化日期
    formatDate(val) {
      const time = this.timestamp + val * this.interval * this.scaleUn * 60 * 1000;
      return DayJs(time).format("YYYY-MM-DD");
    },
    /**
     * 改变刻度视图信息
     * @param scaleNumber 总共分割多少个小刻度
     * @param scaleUn 每一小隔代表分钟数
     * @param interval 几个小刻度展示一个大刻度
     * @param viewType 视图类型--用来计算时间轴的长度，为了实现拖动功能
     * **/
    changeView(scaleNumber, scaleUn, interval, viewType) {
      this.scaleNum = scaleNumber;
      this.scaleUn = scaleUn;
      this.labelInterVal = interval;
      this.viewType = viewType;
      // 重置拖动值
      // this.containerLeft = 0
    },
    // 缩小视图
    handleChangeViewMin() {
      if (this.scale === 0) {
        return;
      }
      this.scale -= 15;
    },
    // 放大视图
    handleChangeViewPlus() {
      if (this.scale === 105) {
        return;
      }
      this.scale += 15;
    },
    handleChangeView(val) {
      console.log("开始时间*************", this.startTime);
      let nowTimeScale = Math.ceil(val / 15);
      if (nowTimeScale > 7) {
        this.scale = 105;
      } else {
        this.scale = 15 * nowTimeScale;
      }
      console.info("拖动的进度信息", val);
      // if (val > 0 && val <= 25) {
      //   console.info('第一时段', this.scale)
      //   this.scale = 0
      //   return
      // }
      // if (val > 25 && val <= 50) {
      //   this.scale = 33.33
      //   console.info('第二时段', this.scale)
      //   return
      // }
      // if (val > 50 && val <= 75) {
      //   this.scale = 66.66
      //   console.info('第三时段', this.scale)
      //   return
      // }
      // if (val > 75 && val <= 100) {
      //   this.scale = 100
      //   console.info('第四时段', this.scale)
      // }
    },
    handleStartTimestamp(val) {},
    handleStartTimeByMax(type) {
      if (type === 72) {
        this.handleMaxView();
        return;
      }
      if (type === 5) {
        this.handleMinView();
        return;
      }
      if (type === 30) {
        this.handleLargeView();
      }
    },
    handleMaxView() {
      // const _Hour = Number(this.getStartTimeM);
      // const _Min = Number(this.getStartTimeS);
      // if (_Hour % 6 === 0) {
      //   this.timestamp = this.startTime;
      //   return;
      // }
      // if (_Hour > 0 && _Hour < 6) {
      //   this.timestamp = this.startTime - _Hour * 60 * 60 * 1000 - _Min * 60 * 1000;
      //   return;
      // }
      // if (_Hour > 6 && _Hour < 12) {
      //   this.timestamp = this.startTime - (_Hour - 6) * 60 * 60 * 1000 - _Min * 60 * 1000;
      //   return;
      // }
      // if (_Hour > 12 && _Hour < 18) {
      //   this.timestamp = this.startTime - (_Hour - 12) * 60 * 60 * 1000 - _Min * 60 * 1000;
      //   return;
      // }
      // if (_Hour > 18) {
      //   this.timestamp = this.startTime - (_Hour - 18) * 60 * 60 * 1000 - _Min * 60 * 1000;
      // }
    },
    handleMinView() {
      // let _Min = this.getStartTimeS;
      // if (Number(_Min) % 5 === 0) {
      //   this.timestamp = this.startTime;
      //   return;
      // }
      // if (Number(_Min) > 10) {
      //   const _m = Number(_Min.substring(0, 1));
      //   const _s = Number(_Min.substring(1, 2));
      //   if (_s > 5) {
      //     this.timestamp = this.startTime - (_s - 5) * 60 * 1000;
      //     return;
      //   }
      //   if (Number(_s) < 5) {
      //     this.timestamp = this.startTime - _s * 60 * 1000;
      //     return;
      //   }
      //   return;
      // }
      // if (Number(_Min) > 5) {
      //   this.timestamp = this.startTime - (Number(_Min) - 5) * 60 * 1000;
      //   return;
      // }
      // this.timestamp = this.startTime - Number(_Min) * 60 * 1000;
    },
    handleLargeView() {
      let _Min = Number(this.getStartTimeS);
      if (_Min % 30 === 0) {
        this.timestamp = this.startTime;
      }
    },
    // 获取UTC时间戳
    handleTimeNumber(val) {
      let yearStr = val.substring(0, 4);
      let monthStr = val.substring(4, 6);
      let dayStr = val.substring(6, 8);
      let hhStr = val.substring(8, 10);
      let mmStr = val.substring(10, 12);
      let ssStr = val.substring(12, 14);
      let _tmpStr =
        yearStr + "/" + monthStr + "/" + dayStr + " " + hhStr + ":" + mmStr + ":" + ssStr;
      return new Date(_tmpStr).getTime(); //   + Math.abs(this.localOffset);
    },
    hasClass(start, end) {
      const _s = this.handleTimeNumber(start);
      const _e = this.handleTimeNumber(end);

      const _left = (_s - this.startTime) * this.getSecWidth;
      const _width = (_e - _s) * this.getSecWidth;
      // console.log(_s);
      // console.log(_e);
      //   console.log(_left);
      // console.log(this.startTime);
      // console.log(this.getSecWidth);
      return { left: _left + this.containerLeft + "px", width: _width + "px" };
    },
    hasTypeClass(type) {
      return type === "010" ? "green" : type === "100" ? "" : "red";
    },
    handleClickActive(val) {
      // console.log(val, 'key-----');
      this.activeWindow = val;
      // this.$emit('handleSetActiveWnd', val);
    },
    handleMouseHover(e, key) {
      // if (this.activeWindow !== key) {
      //   return;
      // }
      // 视频段到左侧的距离
      let greenLeft = 0;
      let eventTarget = null;
      let classList = Array.from(e.target.classList);
      if (classList.indexOf("video_data_list") !== -1) {
        greenLeft = parseInt(e.target.style.left.replace(/px/g, ""));
      }
      // 存储当前播放视频段的Left值
      this.playingLeft = greenLeft;
      this.cursorOpacity = 1;
      // 168 录像条距离左侧距离
      // this.paramsText = e.offsetX + '-' + e.clientX + '-' + e.screenX;
      if (
        classList.includes("el-icon-caret-bottom") ||
        classList.includes("cursor_div")
      ) {
        eventTarget = classList.includes("el-icon-caret-bottom")
          ? e.target.offsetParent
          : e;
        this.cursorLeft =
          e.offsetX +
          169 +
          greenLeft +
          (eventTarget.offsetLeft ? eventTarget.offsetLeft : 0);
        this.cursorValue =
          e.offsetX +
          greenLeft +
          (eventTarget.offsetLeft ? eventTarget.offsetLeft : 0) -
          this.containerLeft;
      } else {
        this.cursorLeft = e.offsetX + 169 + greenLeft;
        this.cursorValue = e.offsetX + greenLeft - this.containerLeft;
      }
    },
    handleMouseLeave() {
      this.cursorOpacity = 0;
    },
    // 时间轴滚动事件
    scalWheel(e) {
      // 向上滚动
      if (e.wheelDeltaY > 0) {
        this.handleChangeViewPlus();
      } else {
        this.handleChangeViewMin();
      }
    },
    // 时间轴拖动
    timeAxisDown(e) {
      const timeLenth = e.target.offsetWidth;
      const leftStay = parseInt(e.target.style.left.replace(/px$/, ""));
      let disX = 0;
      // 拖动标识
      const cursorMove = (moveEvent) => {
        disX = moveEvent.clientX - e.clientX;
        this.containerLeft = leftStay + disX;
        if (timeLenth + leftStay + disX <= this.getScaleWidth) {
          this.containerLeft = this.getScaleWidth - timeLenth;
        }
        if (leftStay + disX >= 0) {
          this.containerLeft = 0;
        }
      };
      const cursorLeave = (leaveEvent) => {
        // 取UTC时间
        document.removeEventListener("mousemove", cursorMove);
        document.removeEventListener("mouseup", cursorLeave);
      };
      document.addEventListener("mousemove", cursorMove);
      document.addEventListener("mouseup", cursorLeave);
    },
    // 拖动列表进度标
    cursorDown(e, item, key) {
      const startX = e.target.offsetParent.offsetLeft;
      let disX = 0;
      const timeStart = this.timestamp + this.cursorValue / this.getSecWidth;
      let { index } = this.getVideoPart(item, timeStart, key);
      this.$emit("movingCode", index);
      // 拖动标识
      const cursorMove = (moveEvent) => {
        disX = moveEvent.clientX - e.clientX;
        e.target.offsetParent.style.left = startX + disX + "px";
        console.log(e.target.offsetParent.style.left);
      };
      const cursorLeave = (leaveEvent) => {
        // 拖动状态改为false
        this.$emit("movingCode", null);
        // 取UTC时间
        const timeLeave = this.timestamp + this.cursorValue / this.getSecWidth;
        const startTime = DayJs(timeLeave).format("YYYYMMDDHHmmss");
        // const startTime = DayJs(timeLeave - 8 * 60 * 60 * 1000).format("YYYYMMDDHHmmss");
        const { partItem, index } = this.getVideoPart(item, timeLeave);
        // 判断是否同步播放
        if (this.isSyncPlay) {
          this.handleSyncPlay({
            item: partItem,
            startTime,
            key: 0,
            currentNumber: timeLeave,
          });
        } else {
          this.$emit("handlePlayBackVideo", partItem, startTime, index, key);
        }
        // console.log(partItem, startTime, index, key)
        // if (partItem) {
        // this.$emit('handlePlayBackVideo', partItem, startTime, index, key)
        // }
        document.removeEventListener("mousemove", cursorMove);
        document.removeEventListener("mouseup", cursorLeave);
      };
      document.addEventListener("mousemove", cursorMove);
      document.addEventListener("mouseup", cursorLeave);
    },
    /**
     * @param {list} 数组 当前摄像机视频段集合
     * @param {time} 时间戳 根据时间戳判断当前时间在哪一个视频段
     * */
    getVideoPart(list, time) {
      let info = {
        partItem: { cameraCode: list[0].cameraCode, cameraName: list[0].cameraName },
      };
      if (list && list.length) {
        for (let i = 0; i < list.length; i++) {
          let item = list[i];
          const _s = this.handleTimeNumber(item.StartTime);
          const _e = this.handleTimeNumber(item.EndTime);
          // 判断当前时间戳是否在视频段内
          if (time >= _s && time <= _e) {
            info.partItem = item;
            info.index = i;
            break;
          }
        }
      }
      return info;
    },
    // 获取202010220506格式时间戳
    getTimeNumber(val) {
      let yearStr = val.substring(0, 4);
      let monthStr = val.substring(4, 6);
      let dayStr = val.substring(6, 8);
      let hhStr = val.substring(8, 10);
      let mmStr = val.substring(10, 12);
      let ssStr = val.substring(12, 14);
      let _tmpStr =
        yearStr + "/" + monthStr + "/" + dayStr + " " + hhStr + ":" + mmStr + ":" + ssStr;
      return new Date(_tmpStr).getTime();
    },
    // 根据当前选中行（摄像机）进行分段val--分段数量
    playPart(val) {
      // 没有选中列表情况
      if (this.activeWindow === "" || this.activeWindow === null) {
        this.activeWindow = 0;
      }
      // 取出当前行摄像机数据
      const currentCamrea = this.mData[this.activeWindow];
      console.log(currentCamrea, "分段视频信息");
      if (currentCamrea) {
        // 摄像机第一段开始时间
        const startTime = this.getTimeNumber(currentCamrea[0].StartTime);
        // 摄像机最后一段结束时间
        const endTime = this.getTimeNumber(
          currentCamrea[currentCamrea.length - 1].EndTime
        );
        // 每一段的时间轴长度
        const partLength = (endTime - startTime) / val;
        // 开始索引
        let partDataIndex = 0;
        this.partData = [];
        // 根据索引存储分段信息
        let storePart = (key, partOne) => {
          if (this.partData[key]) {
            this.partData[key].push(partOne);
          } else {
            this.partData[key] = [partOne];
          }
        };
        for (let i = 0; i < val; i++) {
          // 此视频段的结束时间,当成一个切点
          let cutStart = startTime + partLength * i;
          let cutEnd = startTime + partLength * (i + 1);
          for (let j = 0; j < currentCamrea.length; j++) {
            // 当前分段起点大于等于视频段结束时间的说明不需要存储，继续下一次循环
            if (cutStart >= this.getTimeNumber(currentCamrea[j].EndTime)) {
              continue;
            }
            // 当前分段终点小于等于视频段开始时间的说明不需要存储，继续下一次循环
            if (cutEnd <= this.getTimeNumber(currentCamrea[j].StartTime)) {
              partDataIndex += 1;
              break;
            }
            // 分段起点在当前循环视频段内
            if (
              cutStart >= this.getTimeNumber(currentCamrea[j].StartTime) &&
              cutStart <= this.getTimeNumber(currentCamrea[j].EndTime)
            ) {
              // 如果终点也在当前循环视频段内,当前分段结束，跳出循环
              if (
                cutEnd >= this.getTimeNumber(currentCamrea[j].StartTime) &&
                cutEnd <= this.getTimeNumber(currentCamrea[j].EndTime)
              ) {
                storePart(partDataIndex, {
                  StartTime: DayJs(startTime + partLength * i).format("YYYYMMDDHHmmss"),
                  EndTime: DayJs(startTime + partLength * (i + 1)).format(
                    "YYYYMMDDHHmmss"
                  ),
                  cameraName: currentCamrea[0].cameraName,
                  cameraCode: currentCamrea[0].cameraCode,
                });
                partDataIndex += 1;
                break;
              } else {
                storePart(partDataIndex, {
                  StartTime: DayJs(startTime + partLength * i).format("YYYYMMDDHHmmss"),
                  EndTime: currentCamrea[j].EndTime,
                  cameraName: currentCamrea[0].cameraName,
                  cameraCode: currentCamrea[0].cameraCode,
                });
                continue;
              }
            }
            // 结束时间在视频段内
            if (
              cutEnd >= this.getTimeNumber(currentCamrea[j].StartTime) &&
              cutEnd <= this.getTimeNumber(currentCamrea[j].EndTime)
            ) {
              storePart(partDataIndex, {
                StartTime: currentCamrea[j].StartTime,
                EndTime: DayJs(startTime + partLength * (i + 1)).format("YYYYMMDDHHmmss"),
                cameraName: currentCamrea[0].cameraName,
                cameraCode: currentCamrea[0].cameraCode,
              });
              partDataIndex += 1;
              break;
            } else {
              storePart(partDataIndex, currentCamrea[j]);
            }
            // 切点小于结束时间，结束循环
            if (cutEnd <= this.getTimeNumber(currentCamrea[j].EndTime)) {
              partDataIndex += 1;
              break;
            }
          }
        }
        const batchPlay = (playIndex) => {
          this.$emit(
            "handlePlayBackVideo",
            this.partData[playIndex][0],
            null,
            0,
            playIndex,
            (num) => {
              if (num < this.partData.length) {
                batchPlay(num);
              }
            }
          );
        };
        batchPlay(0);
        // console.log(this.partData, '分段视频数据---');
      } else {
        this.partData = [];
        // console.error('列表没有选择视频');
      }
    },
    // 点击切换播放列表
    switchList(key, item) {
      this.activeWindow = key;
      let startTime = this.handleTimeNumber(item[0].StartTime);
      let endTime = this.handleTimeNumber(item[item.length - 1].EndTime);
      this.$emit("switchCamera", startTime, endTime, this.activeWindow);
    },
    /**
     * 处理同步播放,操作任何视频都从索引0开始依次播放
     * @param {item} 整条摄像机视频
     * @param {startTime} 播放开始时间YYYYMMDDHHmmss UTC时间后退8小时
     * @param {key} 当前摄像机在列表中索引
     * @param {currentNumber} 当前播放时间戳
     * */
    handleSyncPlay({ item, startTime, key, currentNumber }) {
      // console.log(item, startTime, key, 'item, startTime, index, key', this.isSyncPlay);
      const { partItem, index } = this.getVideoPart(this.mData[key], currentNumber);
      this.$emit("handlePlayBackVideo", partItem, startTime, index, key, (num) => {
        // console.log('播放下一个视频,索引为：', num);
        if (num < this.mData.length) {
          return this.handleSyncPlay({ item, startTime, key: num, currentNumber });
        }
      });
    },
    // 双击播放
    handleClickPlay(e, key, item, index) {
      const startTime = DayJs(
        this.timestamp + this.cursorValue / this.getSecWidth
      ).format("YYYYMMDDHHmmss");
      const currentNumber = this.timestamp + this.cursorValue / this.getSecWidth;
      this.$emit("handlePlayBackVideo", item, startTime, index, key);
    },
    deleteInfo(e, key, list) {
      this.$parent.deleteKey = key;
      // let params = {
      //   text: '删除未播放的列表信息',
      //   value: key
      // }
      this.$emit("deleteInfo");
    },
    // 日期转换为时间戳 20200914112525===》时间戳
    forshijianchuo(time) {
      let startTimeStamp = time;
      let year = startTimeStamp.slice(0, 4) + "-";
      let month = startTimeStamp.slice(4, 6) + "-";
      let day = startTimeStamp.slice(6, 8) + " ";
      let hour = startTimeStamp.slice(8, 10) + ":";
      let minute = startTimeStamp.slice(10, 12) + ":";
      let second = startTimeStamp.slice(12, 14);
      let timer = year + month + day + hour + minute + second;
      return new Date(timer).getTime();
    },
    //
    handleGo(e, key, list) {
      this.isTimeInput = true;
      this.timeloadActive = key;
      this.timeObj = {
        list: list,
        key: key,
      };
      console.log(e, key, list, "e, key, list");
    },
    startVideoPlay() {
      if (this.inputTimeValue.length !== 14) {
        this.$message.error("日期格式输入错误");
        return;
      }
      const item = this.timeObj.list;
      const timeValue = DayJs(this.forshijianchuo(this.inputTimeValue)).valueOf();
      const startTime = DayJs(timeValue - 8 * 60 * 60 * 1000).format("YYYYMMDDHHmmss");
      let { index } = this.getVideoPart(item, timeValue, this.timeObj.key);
      if (!index && index !== 0) {
        this.$message.error("跳转时间没有视频");
        return;
      }
      if (this.isSyncPlay) {
        this.handleSyncPlay({
          item: item[index],
          startTime,
          partIndex: index,
          key: 0,
          currentNumber: timeValue,
        });
      } else {
        this.$emit(
          "handlePlayBackVideo",
          item[index],
          startTime,
          index,
          this.timeObj.key
        );
      }
    },
    cancelVideoPlay() {
      this.isTimeInput = false;
      this.timeloadActive = "";
    },
    handleDownload(e, key, list) {
      this.$emit("watchIsShow");
      if (!this.canDownLoad) {
        this.$message.error("正在下载中，请稍候");
        return;
      }
      // console.log(this.playTime, new Date(this.playTime).getTime(), (new Date(this.playTime).getTime() - this.timestamp) * this.getSecWidth, '当前下载图的left值')
      let _y = document.body.clientHeight - e.clientY;
      if (_y < 60) {
        this.isBottom = true;
      } else {
        this.isBottom = false;
      }
      this.downloadActive = key;
      let _playTime = this.handleTimeNumber(list.StartTime);
      // 播放中的视频--现在按钮从播放时间开始选
      if (this.playListInfo[key]) {
        _playTime = this.playListInfo[key];
      }
      const _cur = _playTime - this.timestamp;
      let _before = 15 * 60 * 1000;
      // let _left = _cur * this.getSecWidth
      if (_cur < 15 * 60 * 1000) {
        _before = _cur;
        // _left = 32
      } else {
        // _left = (_playTime - this.timestamp) * this.getSecWidth + 32
      }
      this.cursorOpacity = 0;
      // this.cursorLeft = _cur * this.getSecWidth + 135 + 32;
      // this.cursorValue = _cur * this.getSecWidth;
      // this.paramsText = '执行-----kkkkkkkkkkkkkkkkkkkkkkkkkkk---' + _cur+ 'dengdneg' + this.getSecWidth
      // this.paramsText = '下载zhong-------------' + (_y < 60);
      // this.downloadDefault.left = _left
      this.downloadDefault.width = (_before + 15 * 60 * 1000) * this.getSecWidth;
      this.isDownload = true;
    },
    handleDownloadConfirm(cameraCode, cameraName) {
      // console.log(this.mData, 'this.mData');
      // console.log(cameraCode, 'cameraCode');
      // -----------UTC时间-----------
      let _start = DayJs(this.getDownloadStartTime + this.localOffset);
      let _end = DayJs(this.getDownloadEndTime + this.localOffset);
      // -----------非UTC时间-----------
      // let _start = DayJs(this.getDownloadStartTime);
      // let _end = DayJs(this.getDownloadEndTime);
      let StartTime = _start.format("YYYYMMDDHHmmss");
      let EndTime = _end.format("YYYYMMDDHHmmss");
      // console.info('DayJs(this.getDownloadStartTime)', DayJs(this.getDownloadStartTime));
      // console.info('DayJs(this.getDownloadEndTime)', DayJs(this.getDownloadEndTime));
      // console.info('下载视频#开始时间', StartTime);
      // console.info('下载视频#结束时间', EndTime);
      // this.paramsText = cameraCode + '=========' + StartTime + '下2载时间' + EndTime;
      if (_end - _start <= 0) {
        this.$socMessage.error("下载的时间范围不能小于1秒");
        return;
      }
      // 视频下载方法
      this.$emit("handleDownloadVideo", StartTime, EndTime, cameraCode, cameraName);
      this.isDownload = false;
      this.downloadActive = "";
      this.cursorOpacity = 0;
    },
    handleCancelDownload() {
      this.isDownload = false;
      this.downloadActive = "";
      this.cursorOpacity = 0;
    },
    handleStartDrag(event) {
      this.isDrag = true;
      let _startX = event.clientX;
      // console.info('初始值#', _startX);
      let mouseMove = (e) => {
        if (this.isDrag) {
          // console.log(e.clientX - _startX, '移动距离');
          let _moveValue = e.clientX - _startX;
          if (_moveValue > 0) {
            if (this.getDownloadWidth <= 0) {
              return;
            }
            this.moveLeft = _moveValue;
            this.moveValue = -_moveValue;
          } else {
            if (this.getDownloadLeft <= 32) {
              this.moveLeft = 0;
              this.downloadDefault.left = 32;
              return;
            }
            this.moveLeft = _moveValue;
            this.moveValue = Math.abs(_moveValue);
          }
        }
      };
      let mouseUp = () => {
        // console.info('事件移除');
        this.isDrag = false;
        this.downloadDefault.width = this.getDownloadWidth;
        this.downloadDefault.left = this.getDownloadLeft;
        this.moveLeft = 0;
        this.moveValue = 0;
        document.removeEventListener("mousemove", mouseMove);
        document.removeEventListener("mouseup", mouseUp);
        mouseMove = null;
        mouseUp = null;
      };
      document.addEventListener("mousemove", mouseMove);
      document.addEventListener("mouseup", mouseUp);
    },
    handleEndDrag(event) {
      this.isDrag = true;
      let _startX = event.clientX;
      // console.info('初始值#', _startX);
      let mouseMove = (e) => {
        if (this.isDrag) {
          let _move = e.clientX - _startX;
          if (_move < 0) {
            if (this.getDownloadWidth <= 0) {
              return;
            }
            this.moveValue = _move;
          } else {
            if (this.getDownloadWidth + this.getDownloadLeft - 32 >= this.getScaleWidth) {
              return;
            }
            this.moveValue = _move;
          }
          console.info("拖动的距离是#", this.moveValue);
        }
      };
      let mouseUp = () => {
        console.info("事件移除");
        this.isDrag = false;
        this.downloadDefault.width = this.getDownloadWidth;
        this.moveValue = 0;
        document.removeEventListener("mousemove", mouseMove);
        document.removeEventListener("mouseup", mouseUp);
        mouseMove = null;
        mouseUp = null;
      };
      document.addEventListener("mousemove", mouseMove);
      document.addEventListener("mouseup", mouseUp);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/ioc/pages/common.scss";

.soc_back_videos {
  height: 100%;
  width: 100%;
  background-color: #131e29;
  margin-top: 4px;
  border-top: #394567 solid 1px;
  position: relative;
  display: flex;
  flex-direction: column;

  .back_mark {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 98;
    background-color: rgba(#000, 0.2);
    left: 0;
    top: 0;
  }

  .video_cursor {
    position: absolute;
    width: 1px;
    height: 150px;
    background-color: #66d1b5;
    z-index: 98;
    top: 0;
    left: 0;

    .video_cursor_content {
      width: 100%;
      height: 100%;
      position: relative;

      .time_format {
        width: 130px;
        position: fixed;
        z-index: 1;
        margin-left: -65px;
        margin-top: -15px;
        background-color: rgba(#000, 0.3);
        color: #fff;
        white-space: nowrap;
        font-size: 12px;
        text-align: center;
      }
    }
  }

  .list_content_container {
    flex: 1;
    overflow-y: auto;
    scrollbar-arrow-color: $soc-color-background; /**/
    /*三角箭头的颜色*/
    scrollbar-face-color: $soc-color-background; /**/
    /*立体滚动条的颜色*/
    scrollbar-3dlight-color: #131e29; /**/
    /*立体滚动条亮边的颜色*/
    scrollbar-highlight-color: #131e29; /**/
    /*滚动条空白部分的颜色*/
    scrollbar-shadow-color: #131e29; /**/
    /*立体滚动条阴影的颜色*/
    scrollbar-darkshadow-color: #131e29; /**/
    /*立体滚动条强阴影的颜色*/
    scrollbar-track-color: #131e29; /**/
    /*立体滚动条背景颜色*/
    scrollbar-base-color: #131e29; /**/
    /*滚动条的基本颜色*/
  }

  .back_camera_item {
    height: 30px;
    border-bottom: #272e42 solid 1px;
    display: flex;
    flex-direction: row;
    align-items: center;

    &.active {
      background-color: $soc-color-background;

      .camera_back_data {
        .down_load_icon {
          opacity: 1;
        }

        .data_content {
          .cursor_div {
            opacity: 1;
          }

          .video_data_list {
            opacity: 1;
          }
        }
      }
    }

    &.download {
      background-color: transparent !important;

      .camera_back_data {
        .down_load_icon {
          opacity: 0.2 !important;
        }

        .data_content {
          .cursor_div {
            opacity: 0.2 !important;
          }

          .video_data_list {
            opacity: 0.2 !important;
          }
        }
      }
    }

    .camera_title {
      width: 135px;
      border-right: rgba(#586583, 0.5) solid 1px;
      height: 100%;
      font-size: 12px;
      color: $soc-font-color;
      /*overflow: hidden;*/
      text-overflow: ellipsis;
      white-space: nowrap;
      line-height: 30px;
      padding: 0 7px 0 16px;

      &.noresize {
        overflow: hidden;
      }

      &.nor {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 0;

        i {
          margin: 0 7px;
          cursor: pointer;
        }
      }
    }

    .camera_back_data {
      flex: 1;
      height: 100%;
      padding: 0 86px 0 32px;
      position: relative;

      &.time_scale {
        overflow: hidden;
      }

      // 刻度是拖动样式
      .camera_back_data--over {
        width: 100%;
        height: 100%;
        position: relative;

        &.colResize {
          cursor: col-resize;
        }

        &.width_scal_ {
          &2hour {
            width: 300%;
          }

          &1hour {
            width: 600%;
          }

          &30minute {
            width: 1200%;
          }

          &15minute {
            width: 2400%;
          }
        }
      }

      .download_container {
        width: 100px;
        position: absolute;
        z-index: 101;
        height: 20px;
        top: 5px;
        background-color: $soc-primary-color;

        .download_content {
          width: 100%;
          height: 100%;
          position: relative;

          .download_content_left_cur {
            position: absolute;
            width: 6px;
            height: 100%;
            top: 0;
            left: -8px;
            background-color: #d8d8d8;
            border-bottom-left-radius: 8px;
            border-top-left-radius: 8px;
            z-index: 2;
            cursor: pointer;

            &:hover::before {
              content: attr(data-title); //取到data-title属性的值
              display: inline-block;
              border: 1px solid #313a5b;
              background: #313a5b;
              text-align: center;
              border-radius: 2px;
              padding: 2px 3px;
              position: fixed;
              font-size: 12px;
              height: 20px;
              z-index: 33;
              line-height: 20px;
              margin-left: -20px;
              margin-top: -30px;
              color: #fff;
              white-space: nowrap;
            }
          }

          .download_content_right_cur {
            position: absolute;
            width: 6px;
            height: 100%;
            top: 0;
            right: -8px;
            background-color: #d8d8d8;
            border-bottom-right-radius: 8px;
            border-top-right-radius: 8px;
            z-index: 2;
            cursor: pointer;

            &:hover::before {
              content: attr(data-title); //取到data-title属性的值
              display: inline-block;
              border: 1px solid #313a5b;
              background: #313a5b;
              text-align: center;
              border-radius: 2px;
              padding: 2px 3px;
              position: fixed;
              font-size: 12px;
              height: 20px;
              line-height: 20px;
              margin-left: -20px;
              margin-top: -30px;
              z-index: 2;
              color: #fff;
              white-space: nowrap;
            }
          }

          .download_btn {
            position: absolute;
            top: 22px;
            left: 0px;
            z-index: 1;
            width: 138px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;

            &.bottom {
              top: -43px;
            }
          }
        }
      }

      .down_load_icon {
        position: absolute;
        z-index: 10;
        height: 100%;
        right: 10px;
        top: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        opacity: 0;
        cursor: pointer;

        i {
          color: $soc-font-color;
          font-size: 20px;

          &:hover {
            color: $soc-primary-color;
          }
        }
      }

      .data_content {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        position: relative;
        // overflow: hidden;

        .cursor_div {
          width: 11px;
          height: 12px;
          position: absolute;
          left: 0;
          top: 5px;
          z-index: 9;
          opacity: 0.2;
          left: -7px;
          cursor: pointer;

          .svg-cursor {
            width: 11px !important;
            height: 12px !important;
            vertical-align: 0em !important;
          }

          .cursor_div_content {
            width: 100%;
            height: 100%;
            /*background-color: #000;*/
            position: relative;
            box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.2);
            padding: 0;

            em {
              display: block;
              border-width: 5px;
              position: absolute;
              top: 10px;
              left: 0;
              border-style: solid dashed dashed;
              border-color: #fff transparent transparent;
              font-size: 0;
              line-height: 0;
              z-index: 99;
            }
          }
        }

        .video_data_list {
          background-color: #25519d !important; // $soc-primary-color;
          position: absolute;
          width: auto;
          left: 0;
          top: 5px;
          z-index: 2;
          height: 20px;
          opacity: 0.2;
          box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.12);

          &.green {
            cursor: pointer;
            background-color: #66d1b5;
            z-index: 1;
          }

          &.red {
            background-color: #66d1b5;
            z-index: 3;
          }
        }
      }

      .scale_container {
        width: 100%;
        display: flex;
        flex-direction: row;
        cursor: auto;

        .scale_un {
          position: relative;

          &:first-child {
            &::before {
              content: "";
              height: 10px;
              width: 1px;
              background: #586583;
              position: absolute;
            }

            .label {
              position: absolute;
              width: 70px;
              z-index: 1;
              top: 14px;
              left: -30px;
              font-size: 10px;
              color: $soc-font-color;
              -webkit-transform: scale(0.84);
            }
          }

          &.ps {
            height: 7px;

            .label {
              position: absolute;
              z-index: 1;
              width: 30px;
              top: 14px;
              right: -15px;
              font-size: 10px !important;
              color: $soc-font-color;
              -webkit-transform: scale(0.84);
              text-align: center;
              white-space: nowrap;
            }
          }

          flex: 1;
          border-right: #586583 solid 1px;
          height: 3px;
        }
      }
    }
  }
}
</style>
<style scoped>
* >>> .timeClassContent div input {
  height: 20px;
}

/** >>> .timeClassContent div span{*/
/*line-height: 5px;*/
/*margin-bottom: 10px;*/
/*}*/
</style>
